var _path, _path2, _path3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChartHigh({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 130,
    height: 66,
    viewBox: "0 0 130 66",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M129 1C108.204 2.73299 106.916 44.2218 86.3333 49C69.3602 52.9402 60.7655 30.5738 43.6667 33C25.1204 35.6316 19.1855 58.9382 1 65H129V1Z",
    fill: "#ECFDF3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M129 1C108.204 2.73299 106.916 44.2218 86.3333 49C69.3602 52.9402 60.7655 30.5738 43.6667 33C25.1204 35.6316 19.1855 58.9382 1 65H129V1Z",
    fill: "url(#paint0_linear_16_23559)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1 65C19.1855 58.9382 25.1204 35.6316 43.6667 33C60.7655 30.5738 69.3602 52.9402 86.3333 49C106.916 44.2218 108.204 2.73299 129 1",
    stroke: "#12B76A",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_16_23559",
    x1: 65,
    y1: 1,
    x2: 65,
    y2: 65,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.641167,
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChartHigh);
export default __webpack_public_path__ + "static/media/ChartHigh.498c896ba1165387ad13cba2a88ed6a6.svg";
export { ForwardRef as ReactComponent };